// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { screen } from "@rugby/XDL/Helpers";
import { css } from "styled-components";

interface MyAccountOverlayStyles {
    MyAccountWrapper: InjectableCss;
    titleWrapper: InjectableCss;
    mainTitle: InjectableCss;
    secondTitle: InjectableCss;
    groupTitle: InjectableCss;
    link: InjectableCss;
    localBranchWrapper: InjectableCss;
    localBranchInfo: InjectableCss;
    icons: InjectableCss;
    buttonsWrapper: InjectableCss;
    buttons: InjectableCss;
}

export const myAccountOverlayStyles: MyAccountOverlayStyles = {
    MyAccountWrapper: {
        css: css`
            width: 514px;
            max-width: 514px;

            ${screen("lte", "sm")`
                max-width: 100%;
            `}
        `,
    },
    titleWrapper: {
        css: css`
            ${screen("lte", "sm")`
                padding: 20px 10px;
            `}
        `,
    },
    mainTitle: {
        css: css`
            &&& > span {
                color: ${getColor("common.toast.light")};
                font-size: 28px;
                letter-spacing: 0;
                line-height: 30px;
            }
        `,
    },
    secondTitle: {
        css: css`
            color: #424342;
            font-size: 15px;
            letter-spacing: 0;
            line-height: 22px;
            margin-top: 5px;
        `,
    },
    groupTitle: {
        css: css`
            border-top: 1px solid ${getColor("common.border")};
            padding-top: 7px;
            margin-top: 25px;
            margin-bottom: 15px;
            width: 100%;
            color: ${getColor("common.toast.light")};
            font-size: 13px;
            font-weight: bold;
            letter-spacing: 1px;
            line-height: 16px;
            text-transform: uppercase;

            ${screen("lte", "sm")`
                margin-top: 0;
                padding-left: 10px;
            `}
        `,
    },
    link: {
        css: css`
            width: 50%;
            text-align: left;
            margin-bottom: 2px;

            &&& > span {
                color: ${getColor("secondary")};
                font-size: 15px;
                letter-spacing: 0;
                line-height: 22px;
            }

            &&&:hover > span {
                color: ${getColor("text.link")};
            }

            ${({ theme }: any) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 100%;
                            padding: 0 10px;
                        `,
                        null,

                        null,
                    ],
                    "max",
                )};
        `,
    },
    localBranchWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;

            & > div {
                display: flex;
                flex-direction: column;
                width: 50%;

                ${({ theme }: any) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                margin-bottom: 10px;
                                padding: 10px;
                            `,
                            null,

                            null,
                        ],
                        "max",
                    )};
            }
        `,
    },
    localBranchInfo: {
        css: css`
            &&& {
                color: ${getColor("secondary")};
            }
            font-size: 15px;
            letter-spacing: 0;
            line-height: 22px;

            a span {
                color: ${getColor("secondary")};
            }
            a:hover span {
                color: ${getColor("text.link")};
            }
        `,
    },
    icons: {
        css: css`
            height: 13px;
            width: 20px;
            position: relative;
            top: 6px;
            margin-right: 5px;
            color: ${getColor("common.brand3")};
        `,
    },
    buttonsWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            margin-top: 25px;

            justify-content: ${(props: any) => props.displayChangeCustomerLink ? "space-between" : "flex-end"};

            ${screen("lte", "sm")`
                padding: 0 10px;
            `}
        `,
    },
    buttons: {
        css: css`
            width: calc(50% - 3px);
            ${({ theme }: any) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 100%;
                            margin-bottom: 10px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )};
        `,
    },
};
